import sample_1 from './100_39253.jpg';
import sample_2 from './100_39257.jpg';

export const traditionImpressions = {
    sample_1,
    sample_2,
};
